<template>
  <div class="cloud-warehouse">
    <!-- 统计卡片 -->
    <el-row :gutter="16" class="stats-row">
      <el-col :span="4">
        <div class="stat-card" :class="{ active: currentStatus === '' }" @click="switchStatus('')">
          <p class="stat-num">{{ stats.total }}</p>
          <p class="stat-label">全部</p>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="stat-card consigning" :class="{ active: currentStatus === '1' }" @click="switchStatus('1')">
          <p class="stat-num">{{ stats.consigning }}</p>
          <p class="stat-label">托管中</p>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="stat-card part-sold" :class="{ active: currentStatus === '5' }" @click="switchStatus('5')">
          <p class="stat-num">{{ stats.part_sold }}</p>
          <p class="stat-label">部分售出</p>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="stat-card sold" :class="{ active: currentStatus === '2' }" @click="switchStatus('2')">
          <p class="stat-num">{{ stats.sold }}</p>
          <p class="stat-label">已售出</p>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="stat-card cancelled" :class="{ active: currentStatus === '3' }" @click="switchStatus('3')">
          <p class="stat-num">{{ stats.cancelled }}</p>
          <p class="stat-label">已取消</p>
        </div>
      </el-col>
    </el-row>

    <!-- 搜索/筛选栏 -->
    <el-card shadow="never" class="filter-card">
      <div class="filter-row">
        <div class="search-box">
          <el-select v-model="filterBranchId" placeholder="全部分身商" size="small" style="width: 180px;" clearable @change="onFilterChange">
            <el-option v-for="b in branchOptions" :key="b.id" :label="b.name" :value="b.id" />
          </el-select>
          <el-input v-model="keyword" placeholder="商品名称 / 托管人手机号" size="small" style="width: 260px" clearable @keyup.enter.native="search" />
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </div>
      </div>
    </el-card>

    <!-- 托管商品表格 -->
    <el-card shadow="never" style="margin-top:16px">
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column label="商品信息" min-width="220">
          <template slot-scope="scope">
            <div class="goods-info">
              <el-image :src="scope.row.goods_img" style="width:48px;height:48px;border-radius:4px" fit="cover">
                <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
              </el-image>
              <div class="goods-text">
                <p class="goods-name">{{ scope.row.goods_name }}</p>
                <p class="goods-spec" v-if="scope.row.spec_text">{{ scope.row.spec_text }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所属分身商" width="140">
          <template slot-scope="scope">
            <el-tag type="info" size="small">{{ scope.row.branch_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="托管人" width="140">
          <template slot-scope="scope">
            <div class="member-info">
              <p class="member-name">{{ scope.row.member_name }}</p>
              <p class="member-phone" v-if="scope.row.member_phone">{{ scope.row.member_phone }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" width="100">
          <template slot-scope="scope">&yen; {{ scope.row.price }}</template>
        </el-table-column>
        <el-table-column label="托管数量" width="80">
          <template slot-scope="scope">{{ scope.row.quantity }}</template>
        </el-table-column>
        <el-table-column label="已售" width="70">
          <template slot-scope="scope">{{ scope.row.sold_quantity }}</template>
        </el-table-column>
        <el-table-column label="剩余" width="70">
          <template slot-scope="scope">
            <span :class="{ 'remain-zero': scope.row.remain_quantity <= 0 }">{{ scope.row.remain_quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column label="托管金额" width="110">
          <template slot-scope="scope">&yen; {{ scope.row.total_amount }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.status)" size="small">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="托管时间" width="160">
          <template slot-scope="scope">{{ scope.row.create_time }}</template>
        </el-table-column>
        <el-table-column label="售出信息" min-width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 2 || scope.row.status === 5">
              <p v-if="scope.row.sold_price">售出价: &yen; {{ scope.row.sold_price }}</p>
              <p v-if="scope.row.income_amount">收益: &yen; {{ scope.row.income_amount }}</p>
              <p v-if="scope.row.sold_time" class="sold-time">{{ scope.row.sold_time }}</p>
            </div>
            <span v-else class="no-data">-</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="onPageChange" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getCloudWarehouse, getCloudWarehouseStats, getCloudWarehouseBranches } from '@/api'

export default {
  name: 'CloudWarehouse',
  data() {
    return {
      loading: false,
      keyword: '',
      currentStatus: '',
      filterBranchId: '',
      branchOptions: [],
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      stats: {
        total: 0,
        consigning: 0,
        part_sold: 0,
        sold: 0,
        cancelled: 0
      }
    }
  },
  created() {
    this.fetchBranches()
    this.fetchStats()
    this.fetchList()
  },
  methods: {
    async fetchBranches() {
      try {
        const res = await getCloudWarehouseBranches()
        if (res) {
          this.branchOptions = res || []
        }
      } catch (e) {
        // ignore
      }
    },
    async fetchStats() {
      try {
        const params = {}
        if (this.filterBranchId) params.branch_id = this.filterBranchId
        const res = await getCloudWarehouseStats(params)
        if (res) {
          this.stats = {
            total: res.total || 0,
            consigning: res.consigning || 0,
            part_sold: res.part_sold || 0,
            sold: res.sold || 0,
            cancelled: res.cancelled || 0
          }
        }
      } catch (e) {
        // ignore
      }
    },
    async fetchList() {
      this.loading = true
      try {
        const params = {
          page: this.page,
          limit: this.pageSize
        }
        if (this.currentStatus !== '') {
          params.status = this.currentStatus
        }
        if (this.filterBranchId) {
          params.branch_id = this.filterBranchId
        }
        if (this.keyword) {
          params.keyword = this.keyword
        }
        const res = await getCloudWarehouse(params)
        if (res) {
          this.list = res.list || []
          this.total = res.total || 0
        }
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    switchStatus(status) {
      this.currentStatus = status
      this.page = 1
      this.fetchList()
    },
    onFilterChange() {
      this.page = 1
      this.fetchStats()
      this.fetchList()
    },
    search() {
      this.page = 1
      this.fetchList()
    },
    resetSearch() {
      this.keyword = ''
      this.currentStatus = ''
      this.filterBranchId = ''
      this.page = 1
      this.fetchStats()
      this.fetchList()
    },
    onPageChange(page) {
      this.page = page
      this.fetchList()
    },
    statusTag(status) {
      const map = { 1: 'warning', 2: 'success', 3: 'info', 5: '' }
      return map[status] || 'info'
    }
  }
}
</script>

<style scoped>
.stats-row {
  margin-bottom: 16px;
}
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  border: 2px solid transparent;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.2s;
}
.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.stat-card.active {
  border-color: #3a8ee6;
}
.stat-card.consigning.active {
  border-color: #e6a23c;
}
.stat-card.part-sold.active {
  border-color: #e6a23c;
}
.stat-card.sold.active {
  border-color: #67c23a;
}
.stat-card.cancelled.active {
  border-color: #909399;
}
.stat-num {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #303133;
}
.stat-label {
  font-size: 13px;
  color: #909399;
  margin: 0;
}
.filter-card {
  border-radius: 8px;
}
.filter-row {
  display: flex;
  align-items: center;
}
.search-box {
  display: flex;
  gap: 8px;
  align-items: center;
}
.goods-info {
  display: flex;
  align-items: center;
  gap: 10px;
}
.goods-text {
  flex: 1;
  min-width: 0;
}
.goods-name {
  margin: 0;
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.goods-spec {
  margin: 2px 0 0;
  font-size: 12px;
  color: #909399;
}
.member-name {
  margin: 0;
  font-size: 13px;
  color: #303133;
}
.member-phone {
  margin: 2px 0 0;
  font-size: 12px;
  color: #909399;
}
.remain-zero {
  color: #f56c6c;
}
.sold-time {
  margin: 2px 0 0;
  font-size: 12px;
  color: #909399;
}
.no-data {
  color: #c0c4cc;
}
.pagination-box {
  margin-top: 16px;
  text-align: right;
}
</style>
